import React, { useState } from 'react';
import { FastButtonDiv } from './FastButtonStyled';
import { ReactComponent as FastSvg } from './fast.svg';

const FastButton = ({ audio, SFX, func, speed }: any) => {
  const { sound } = audio;
  const [isTurboOn, setisTurboOn] = useState(speed === 2);
  const [fast, setfast] = useState(speed === 2);

  return (
    <FastButtonDiv
      onClick={() => {
        setisTurboOn((isTurboOn) => {
          if (sound && !isTurboOn) SFX.play();
          setfast(!isTurboOn);
          return !isTurboOn;
        });
        setfast(true);
        setTimeout(() => {
          setfast(false);
        }, 300);
        func(true);
      }}
      isTurboOn={isTurboOn}
      animOn={fast}
    >
      <div className="white"></div>
      <FastSvg />
    </FastButtonDiv>
  );
};

export default FastButton;
